$(function () {
    'use strict';

    activate();

    ////////////////////

    function activate() {
        var skin = $('.header_skin_life').length ? 'life' : 'main';

        /* Set class name and skin specific class name */
        $('.share-bar--sticky').addClass('share-bar_skin_' + skin);

        $(document)
            .on('stickyNav:on', onStickyBegin)
            .on('stickyNav:off', onStickyStop);

        $(window)
            .on('resize', onWindowResize);

        syncPosition();
    }

    function onStickyBegin() {
        $("body").addClass("bpage-sticky-nav-on");
        $('.share-bar--sticky').addClass('sticky');
        syncPosition();
    }

    function onStickyStop() {
        $("body").removeClass("bpage-sticky-nav-on");
        $('.share-bar--sticky').removeClass('sticky');
        syncPosition();
    }

    function onWindowResize() {
        syncPosition();
    }

    function syncPosition() {
        var $shareBar = $('.share-bar--sticky');
        var $pageContent = $('.page__content');
        var isSticky = $shareBar.hasClass('sticky');

        $shareBar.show();

        if ($pageContent.length) {
            if (isSticky) {
                var left = Math.floor($pageContent.offset().left - $shareBar.outerWidth(true));
                $shareBar.css('left', left + 'px');
            } else {
                $shareBar.css('left', '');
            }
        }
    }
});
